import { config } from '../core';

export default class ResizeReload {
  constructor() {
    this.currentWidth = window.innerWidth;
    this.newWidth;
    this.init();
  }

  init() {
    this.onResize();
  }

  onResize() {
    window.addEventListener('resize', () => {
      this.newWidth = window.innerWidth;
      if ((this.currentWidth >= config.viewport.md && this.newWidth < config.viewport.md) || (this.currentWidth <= config.viewport.sm && this.newWidth > config.viewport.sm)) {
        location.reload();
      }
      this.currentWidth = this.newWidth;
    });
  }
}
